module.exports = "//docs.gtimg.com/slide/img/framework/editor/src/img/readrecord_retina-a13cce.png";